import React from "react";
import PaginationButton from "./PaginationButton";

type PageItem = number | '...';

function getPaginationItems(current: number, total: number): PageItem[] {
  if (total <= 11) {
    // 小量頁面：全部顯示
    return Array.from({ length: total }, (_, i) => i + 1);
  }

  const clamp = (n: number) => Math.min(total, Math.max(1, n));

  // 三個區段：前3、當前±2（5個）、後3
  const first = [1, 2, 3].filter(n => n <= total);
  const middle = Array.from({ length: 5 }, (_, i) => clamp(current - 2 + i));
  const last = [total - 2, total - 1, total].filter(n => n >= 1);

  // 合併後排序去重
  const merged = Array.from(new Set([...first, ...middle, ...last])).sort((a, b) => a - b);

  // 插入省略號：相鄰數字差 > 1 時補 '...'
  const items: PageItem[] = [];
  for (let i = 0; i < merged.length; i++) {
    items.push(merged[i]);
    const next = merged[i + 1];
    if (next !== undefined && next - merged[i] > 1) items.push('...');
  }
  return items;
}

interface PaginationBarProps {
  currentPage: number;
  numberOfPages: number;
  onPageChange: (page: number) => void;
}

export const PaginationBar = ({
  currentPage,
  numberOfPages,
  onPageChange
}: PaginationBarProps) => {

  const items = getPaginationItems(currentPage, numberOfPages);
  const go = (page: number) => {
    onPageChange(Math.min(numberOfPages, Math.max(1, page)));
  }

  return (
    <div className="flex flex-row flex-1 justify-center mt-6 gap-2">
      {/* 上一頁 */}
      <PaginationButton
        isSelected={false}
        label="上一頁"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
      />

      {/* 中間頁碼 + 省略號 */}
      {items.map((it, idx) =>
        it === '...' ? (
          <span
            key={`ellipsis-${idx}`}
            className="px-3 py-2 text-gray-500 select-none"
          >
            …
          </span>
        ) : (
          <PaginationButton
            key={it}
            isSelected={it === currentPage}
            label={String(it)}
            onClick={() => go(it)}
          />
        )
      )}

      {/* 下一頁 */}
      <PaginationButton
        isSelected={false}
        label="下一頁"
        onClick={() => onPageChange(Math.min(numberOfPages, currentPage + 1))}
      />
    </div>
  )
}